export enum TipoAutorizacaoPortariaEnum {
  Visitante = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9361",
  Encomenda = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9362",
  Transporte = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9363",
  Delivery = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9364",
  PrestadorServico = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9365",
  FuncionarioDomestico = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9366",
  ListaConvidados = "E2D477BD-0E21-4D0E-8AF4-092EC3CB9367",
}

export enum StatusAutorizacaoPortaria {
  Ativo = "ativo",
  Cancelado = "cancelado",
  Confirmado = "confirmado",
}
